/* eslint perfectionist/sort-enums: ["warn", { partitionByComment: true }] */
import type { QuestTaskRequirement } from '@noah-labs/shared-schema-gql';

export enum TpAnalyticsEvent {
  // Welcome
  CreateAccountClicked = 'Welcome Create Account Button Click',
  LoginClicked = 'Welcome Log In Button Click',

  // Cards and misc
  ReferAFriendClicked = 'Refer Friend Button Click',
  ReferralLinkCopied = 'Referral Link Copied',
  SocialReferralCardClicked = 'Social Referral Card Clicked',

  // Wallet
  BuyClicked = 'Buy Button Clicked',
  LNInvoiceUrlCopied = 'LN Invoice Url Copied',
  ReceiveClicked = 'Receive Button Clicked',
  SellClicked = 'Sell Button Clicked',
  SendClicked = 'Send Button Clicked',

  // Rewards
  BadgeClicked = 'Badge Clicked',
  QuestClicked = 'Quest Clicked',
  TaskClick = 'Quest Task Clicked',

  // Rewards Only
  SocialCardClicked = 'Social Media Card Clicked',

  // Social Auth
  SocialAuthLink = 'Social Auth Toggle Link Clicked',
  SocialAuthUnlink = 'Social Auth Toggle Unlink Clicked',

  // KYC
  KycVerifyClicked = 'KYC Verify Button Clicked',

  // Passkey
  PasskeyDisabled = 'Passkey Toggle Disabled',
  PasskeyEnabled = 'Passkey Toggle Enabled',

  // Security PIN
  RecoveryPhraseDownloadClicked = 'Recovery Phrase Download Button Clicked',
  SecretPhraseCopyClicked = 'Secret Phrase Copy Button Clicked',

  // Password
  NewPasswordLinkClicked = 'New Password Link Clicked',

  // Withdraw
  WithdrawCanceledAfterFeeIncrease = 'Withdraw Canceled After Fee Increase',
  WithdrawFeeIncreased = 'Withdraw Fee Increased',
  WithdrawFeeQuoteExpired = 'Withdraw Fee Quote Expired',
  WithdrawOrderStarted = 'Withdraw Order Started',
  WithdrawSubmittedAfterFeeIncrease = 'Withdraw Submitted After Fee Increase',
  WithdrawSubmittedWithUnexpiredFeeQuote = 'Withdraw Submitted With Unexpired Fee Quote',

  // Website
  BookDemo = 'Book Demo Form Submitted',
  Newsletter = 'Newsletter Form Submitted',
}

export type TpEventProperties = {
  [TpAnalyticsEvent.BadgeClicked]: {
    badgeLocked: boolean;
    id: string;
  };
  [TpAnalyticsEvent.BookDemo]: {
    company: string;
    email: string;
    firstName: string;
    lastName: string;
  };
  [TpAnalyticsEvent.BuyClicked]: undefined;
  [TpAnalyticsEvent.CreateAccountClicked]: undefined;
  [TpAnalyticsEvent.KycVerifyClicked]: undefined;
  [TpAnalyticsEvent.LNInvoiceUrlCopied]: undefined;
  [TpAnalyticsEvent.LoginClicked]: undefined;
  [TpAnalyticsEvent.NewPasswordLinkClicked]: undefined;
  [TpAnalyticsEvent.Newsletter]: {
    email: string;
    newsletter: string;
  };
  [TpAnalyticsEvent.PasskeyDisabled]: undefined;
  [TpAnalyticsEvent.PasskeyEnabled]: undefined;
  [TpAnalyticsEvent.QuestClicked]: {
    id: string;
  };
  [TpAnalyticsEvent.ReceiveClicked]: undefined;
  [TpAnalyticsEvent.RecoveryPhraseDownloadClicked]: undefined;
  [TpAnalyticsEvent.ReferAFriendClicked]: undefined;
  [TpAnalyticsEvent.ReferralLinkCopied]: undefined;
  [TpAnalyticsEvent.SecretPhraseCopyClicked]: undefined;
  [TpAnalyticsEvent.SellClicked]: undefined;
  [TpAnalyticsEvent.SendClicked]: undefined;
  [TpAnalyticsEvent.SocialAuthLink]: {
    provider: string;
  };
  [TpAnalyticsEvent.SocialAuthUnlink]: {
    provider: string;
  };
  [TpAnalyticsEvent.SocialCardClicked]: {
    socialMedia: 'Discord' | 'Telegram' | 'Twitter';
  };
  [TpAnalyticsEvent.SocialReferralCardClicked]: {
    platform: string;
  };
  [TpAnalyticsEvent.TaskClick]: {
    requirement: QuestTaskRequirement;
  };
  [TpAnalyticsEvent.WithdrawCanceledAfterFeeIncrease]: undefined;
  [TpAnalyticsEvent.WithdrawFeeIncreased]: undefined;
  [TpAnalyticsEvent.WithdrawFeeQuoteExpired]: undefined;
  [TpAnalyticsEvent.WithdrawOrderStarted]: undefined;
  [TpAnalyticsEvent.WithdrawSubmittedAfterFeeIncrease]: undefined;
  [TpAnalyticsEvent.WithdrawSubmittedWithUnexpiredFeeQuote]: undefined;
};
